<style lang="scss">
.calls {
}
</style>

<!-- eslint-disable -->
<template>
  <div class="theme-color-wrapper p-2 kiosk-page">
    <div class="calls row">
      <div class="col-12">
        <section class="d-flex align-items-center sm-row-drop">
          <h2 cy="page-title" class="font-weight-bolder mb-2">Kiosk</h2>
          <div class="ui-spacer"></div>
          <b-btn class="mr-sm-1" :to="{name: 'kiosk-print'}">View Ordered</b-btn>
          <b-btn @click="showModal('modal-settings', true)" variant="primary" class="mr-sm-1 mb-sm-0 mb-1 sm-full-width">Kiosk Settings</b-btn>
          <b-btn @click="showModal('modal-add', true)" variant="success" class="sm-full-width mb-sm-0 mb-1">Add Item</b-btn>
        </section>

        <p>Kiosk is currently <b v-if="prison">{{prison.allow_kiosk ? "enabled" : "disabled"}}</b> for visitors</p>

        <section class="my-2 mb-3">
          <label>Search for item by name</label>
          <b-form-input @input="filterResults()" placeholder="Search..." cy="kiosk-search" class="full-width" v-model="search"></b-form-input>
        </section>

        <section v-if="!loading">
          <b-table
            class="data-table mx-0 px-0" cy="kiosk-table"
            hover
            :items="kioskItemsFiltered"
            :fields="columns"
            :current-page="currentPage"
            :per-page="perPage"
            :responsive="true"
          >
            <template #cell(actions)="data">
              <b-dropdown class="m-0" variant="link" right toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                  <i class="fas fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item-button class="full-nested-btn"
                                        @click="showModal('modal-edit', true, data.item)">
                  <span class="fas fa-search"></span> Edit
                </b-dropdown-item-button>
                <b-dropdown-item-button class="full-nested-btn"
                                        @click="showModal('modal-delete', true, data.item)">
                  <span class="fas fa-times"></span> Delete
                </b-dropdown-item-button>
              </b-dropdown>
            </template>
          </b-table>
          <b-row>
            <b-col md="6" class="my-1" v-if="kioskItemsFiltered.length > 0">
              <b-pagination :total-rows="kioskItemsFiltered.length" :per-page="perPage" v-model="currentPage" class="my-0"/>
            </b-col>
            <p v-else>No Kiosk items</p>
          </b-row>
        </section>

        <b-spinner class="d-block" v-else variant="primary"></b-spinner>
      </div>
    </div>

    <b-modal id="modal-add" hide-footer>
      <kiosk-add @close="closeAllModalAndRefresh"></kiosk-add>
    </b-modal>

    <b-modal id="modal-edit" hide-footer>
      <kiosk-update v-if="activeItem" :existing-item="activeItem" @close="closeAllModalAndRefresh"></kiosk-update>
    </b-modal>

    <b-modal id="modal-delete" hide-footer>
      <warning-modal v-if="activeItem" title="Are you sure you want to remove"
                     @ok="deleteItem(activeItem)" @close="closeAllModalAndRefresh"
                     :subtitle="activeItem.name + '?'"></warning-modal>
    </b-modal>

    <b-modal id="modal-settings" hide-footer>
      <kiosk-settings v-if="prison" @close="closeAllModalAndRefresh(true)"></kiosk-settings>
    </b-modal>
  </div>
</template>
<!-- eslint-enable -->

<script>
import {mapState} from 'vuex';
import KioskService from '@/services/KioskService';
import KioskAdd from '@/views/kiosk/KioskAdd';
import KioskUpdate from '@/views/kiosk/KioskUpdate';
import WarningModal from '@/components/modals/WarningModal';
import KioskSettings from '@/views/kiosk/KioskSettings';

export default {
  name: 'Kiosk',
  components: {
    KioskAdd,
    KioskUpdate,
    WarningModal,
    KioskSettings,
  },
  props: {},
  data() {
    return {
      loading: true,
      search: '',
      activeItem: null,
      kioskItems: [],
      kioskItemsFiltered: [],
      columns: [
        {key: 'name', label: 'Item Name',},
        {key: 'priceFormatted', label: `Price (${this.$options.filters.regionCurrency()})`,},
        {key: 'stock', label: 'In Stock',},
        {key: 'actions', label: 'Actions',},
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      prison: state => state.prison.prison,
    }),
  },
  mounted() {
    this.$store.dispatch('prison/getPrison');
    this.getKiosk();
  },
  methods: {
    getKiosk() {
      KioskService.getKioskItems().then(res => {
        let items = res.data || [];

        // Order kiosk items
        items = items.sort((k1, k2) => {
          const k1CreatedAt = new Date(k1.created_at);
          const k2CreatedAt = new Date(k2.created_at);
          return k2CreatedAt - k1CreatedAt;
        });
        // Transform kiosk items
        this.kioskItems = items.map((kioskItem) => {
          return {
            ...kioskItem,
            priceFormatted: `${this.$options.filters.regionCurrency()}${kioskItem.price.toFixed(2)}`,
            stock: kioskItem.in_stock ? 'True' : 'False',
          };
        });

        this.filterResults();
      }).catch(err => {
        this.$toast.error('Error getting kiosk items, please check your connection and refresh the page', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    filterResults() {
      this.kioskItemsFiltered = this.kioskItems.filter(item => {
        return item.name.toLowerCase().includes(this.search.toLowerCase());
      });

      if (this.search === '') {
        this.kioskItemsFiltered = [...this.kioskItems];
      }
    },
    showModal(name, value, item = null) {
      this.activeItem = item;
      if (value) {
        this.$bvModal.show(name);
      } else {
        this.$bvModal.hide(name);
      }
    },
    closeAllModalAndRefresh(refreshPrison = false) {
      this.$bvModal.hide('modal-edit');
      this.$bvModal.hide('modal-delete');
      this.$bvModal.hide('modal-add');
      this.$bvModal.hide('modal-settings');
      this.getKiosk();

      if (refreshPrison) {
        this.$store.dispatch('prison/getPrison', true);
      }
    },
    deleteItem(item) {
      KioskService.disableKioskItem(this.prison.prison_id, item._id).then(() => {
        this.$toast.success(`${item.name} has been successfully removed`, {
          toastClassName: ['toast-std', 'success-toast'],
        });
      }).catch(err => {
         this.$toast.error(`Something went wrong removing ${item.name}, please refresh the page try again`, {
           toastClassName: ['toast-std', 'warning-toast'],
         });
      }).finally(() => {
        this.closeAllModalAndRefresh();
      });
    }
  },
}
</script>
